<template>
  <div>
    <div class="setting-nav-title">
      {{ $t("tradeTypeManage") }}
      <!-- <el-button class="confirm pull-right" @click="applyNewPayment">{{ $t("newpayment") }}</el-button> -->
    </div>
    <div style="margin-bottom: 20px;display: flex;    justify-content: space-between;">
      <el-button @click="createDialog = true">CreatePaymentType</el-button>
      <el-select v-model="tenantFilter" @change="gPaymentTypes()">
        <el-option value="">all</el-option>
        <el-option
          v-for="item in tenantList"
          :key="item.tenantId"
          :value="item.tenantName"
          :label="item.tenantName"
        ></el-option>
      </el-select>
    </div>

    <div class="payment-container" v-loading="loading">
      <nodata v-if="paymentTypeList.length === 0" />
      <el-table v-else :data="paymentTypeList">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="paymentType" label="paymentType"></el-table-column>
        <el-table-column prop="displayName" label="displayName"></el-table-column>
        <el-table-column prop="englishName" label="englishName"></el-table-column>
        <el-table-column prop="tenant" label="tenant"></el-table-column>
        <el-table-column prop="tenantId" label="tenantId"></el-table-column>
        <el-table-column prop="paymentClass" label="paymentClass"></el-table-column>
        <el-table-column prop="paymentClassId" label="paymentClassId"></el-table-column>
        
        <el-table-column prop="color" label="color"></el-table-column>
        <el-table-column fixed="right" label="" width="200">
          <template slot-scope="scope">
            <el-button @click="ePaymentType(scope.row)" type="text" size="small">EDIT</el-button>
            <el-button @click="dPaymentType(scope.row)" type="text" size="small">DELETE</el-button>
            <el-button @click="copyPaymentType(scope.row)" type="text" size="small">COPY</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="" :visible.sync="createDialog" v-loading="loading" @close="handelDialogClose" :close-on-click-modal="false">
      <el-form :model="form" ref="form">
        <el-form-item label="tenant" prop="tenant" required>
          <el-input v-model="form.tenant"></el-input>
        </el-form-item>
        <el-form-item label="tenantId" prop="tenantId" required>
          <el-input v-model="form.tenantId"></el-input>
        </el-form-item>
        <el-form-item label="paymentType" prop="paymentType" required>
          <el-input v-model="form.paymentType"></el-input>
        </el-form-item>

        <el-form-item label="paymentClass" prop="paymentClass" required>
          <el-input v-model="form.paymentClass"></el-input>
        </el-form-item>
        <el-form-item label="paymentClassId" prop="paymentClassId" required>
          <el-input v-model="form.paymentClassId"></el-input>
        </el-form-item>
        <el-form-item label="displayName" prop="displayName" required>
          <el-input v-model="form.displayName"></el-input>
        </el-form-item>
        <el-form-item label="englishName" prop="englishName" required>
          <el-input v-model="form.englishName"></el-input>
        </el-form-item>
        <el-form-item label="color" prop="color" required>
          <el-input v-model="form.color"></el-input>
        </el-form-item>
        <el-button @click="cPaymentType()">Submit</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import paymentusing from "@/assets/using.png";
import paymentchecking from "@/assets/checking.png";
import paymentappling from "@/assets/appling.png";
import paymentfailed from "@/assets/failed.png";

import { getTenants } from "api/tenant";
import { getPaymentTypes, createPaymentType, delPaymentType, updatePaymentType } from "api/tradetype";
import { getBigPayLogoByTradeTypeName } from "utils/tradeTypeLogo";
export default {
  data() {
    return {
      loading: false,
      createDialog: false,
      paymentusing,
      paymentchecking,
      paymentappling,
      paymentfailed,
      paylist: [],
      tenantList: [],
      tenantFilter: "netstars",
      paymentClassList: [],
      paymentTypeList: [],
      form: {
        id: 0,
        tenantId: 0,
        tenant: "",
        paymentType: "",
        paymentClassId: 0,
        paymentClass: "",
        displayName: "",
        englishName: "",
        color: ""
      }
    };
  },
  mounted() {
    this.gPaymentTypes();
    getTenants({ pageSize: 9999 }).then(res => {
      console.log(res);
      if (res.statusCode == 200) {
        this.tenantList = res.result;
      }
    });
    // let pc = getPaymentClasses().then(res => {
    //   console.log(res);
    //   if (res.statusCode == 200) {
    //     this.paymentClassList = res.result;
    //   }
    // });
    // let pt = getPaymentTypes().then(res => {
    //   console.log(res);
    //   if (res.statusCode == 200) {
    //     this.paymentTypeList = res.result;
    //   }
    // });
  },
  methods: {
    handelDialogClose() {
      this.form = {
        id: 0,
        tenantId: 0,
        tenant: "",
        paymentType: "",
        paymentClassId: 0,
        paymentClass: "",
        displayName: "",
        englishName: "",
        color: ""
      };
      this.$refs.form.resetFields();
    },
    gPaymentTypes() {
      return getPaymentTypes({ tenant: this.tenantFilter, pageSize: 9999 }).then(res => {
        console.log(res);
        if (res.statusCode == 200) {
          this.paymentTypeList = res.result;
        }
      });
    },
    cPaymentType() {
      this.$refs.form.validate(valid => {
        console.log(valid);
        if (valid) {
          this.loading = true;
          let xhr;

          if (this.form.id > 0) {
            xhr = updatePaymentType(this.form);
          } else {
            xhr = createPaymentType(this.form);
          }

          xhr
            .then(res => {
              this.loading = false;
              console.log(res);
              if (res.statusCode == 200) {
                // this.tenantList = res.result;
                this.createDialog = false;
                this.gPaymentTypes();
              }
            })
            .catch(err => {
              this.loading = false;
            });
        }
      });
    },
    dPaymentType(row) {
      this.$confirm("Confirm?", "warning", {
        type: "warning"
      })
        .then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
          this.loading = true;

          delPaymentType({ id: row.id })
            .then(res => {
              this.loading = false;
              console.log(res);
              if (res.statusCode == 200) {
                this.gPaymentTypes().then(res => {
                  console.log(res);
                  this.loading = false;
                });
              }
            })
            .catch(err => {
              this.loading = false;
            });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    ePaymentType(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.createDialog = true;
    },
    copyPaymentType(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.form.id = 0;
      this.createDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.notification-container {
  margin: 16px 0;
}

.payment-container {
  background: #fffffe;
  box-shadow: 0 2px 12px 0 rgba(103, 95, 119, 0.1);
  border-radius: 8px;
  padding: 0 24px;
}

.payment-item {
  @include flex();

  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &:last-child {
    border: none;
  }

  .payment-img-container {
    width: 122px;
    height: 80px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    position: relative;
    border-radius: 8px;

    & > img {
      width: 90px;
      height: 54px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .payment-content {
    flex: 1;
    padding: 0 30px;

    .payment-name {
      font-size: 16px;
      font-weight: 700;
      line-height: 23px;
    }

    .payment-rate {
      font-size: 12px;
    }
  }

  .payment-status {
    line-height: 24px;

    .payment-status-image {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }

    .status-text {
      font-size: 14px;
      color: #2aa76c;
      font-weight: 700;
      margin-left: 10px;
    }
  }
}
</style>
